import { render, staticRenderFns } from "./ListItemOptionRegion.vue?vue&type=template&id=1488fe9c&scoped=true&"
import script from "./ListItemOptionRegion.vue?vue&type=script&lang=js&"
export * from "./ListItemOptionRegion.vue?vue&type=script&lang=js&"
import style0 from "./ListItemOptionRegion.vue?vue&type=style&index=0&id=1488fe9c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488fe9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1488fe9c')) {
      api.createRecord('1488fe9c', component.options)
    } else {
      api.reload('1488fe9c', component.options)
    }
    module.hot.accept("./ListItemOptionRegion.vue?vue&type=template&id=1488fe9c&scoped=true&", function () {
      api.rerender('1488fe9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/components/ListItemOptionRegion.vue"
export default component.exports